import { FC } from 'react'

import { Card } from 'shared/components/ui/card'

export const HowToPlay: FC = () => {
  return (
    <Card className="mx-auto my-0 h-[calc(100vh-200px)] w-11/12 sm:my-10 sm:w-4/5 lg:w-[800px]">
      <iframe
        className="h-full w-full"
        src="https://docs.google.com/document/d/e/2PACX-1vSV13S3lVcw4m4_DFeVLFrC1RUqGRCrsu26INPjJWmtN5iUlPhm5C2VwobeoSoyAdHrPHYP2Tep3Hp1/pub?embedded=true"
      />
    </Card>
  )
}
